"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTileMapString = parseTileMapString;
function toTileType(str) {
    return str;
}
function parseTileMapString(str) {
    str = str.replace(/\r/g, "\n");
    str = str.replace(/ /g, "");
    const lines = str
        .split("\n")
        .map((row) => row.trim())
        .filter((row) => row.length > 0);
    return lines.map((row) => row.split("").map(toTileType));
}
